/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Popup_Settings_Showtrackerbells2Inputs */

const he_extension_popup_settings_showtrackerbells2 = /** @type {(inputs: Extension_Popup_Settings_Showtrackerbells2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הצג פעמוני מעקב על כרטיסים`)
};

const en_extension_popup_settings_showtrackerbells2 = /** @type {(inputs: Extension_Popup_Settings_Showtrackerbells2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show tracker bells on cards`)
};

/**
* | output |
* | --- |
* | "Show tracker bells on cards" |
*
* @param {Extension_Popup_Settings_Showtrackerbells2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const extension_popup_settings_showtrackerbells2 = /** @type {((inputs?: Extension_Popup_Settings_Showtrackerbells2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Popup_Settings_Showtrackerbells2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_popup_settings_showtrackerbells2(inputs)
	return en_extension_popup_settings_showtrackerbells2(inputs)
});
export { extension_popup_settings_showtrackerbells2 as "extension_popup_settings_showTrackerBells" }